export const computeLayout = (args: { pathname: string; isMobile: boolean; isPartner: boolean }) => {
  const { pathname, isMobile, isPartner } = args;
  const mainPath = pathname.split('/')?.[1];
  const landingPage = ['join', 'login', 'auth', 'invite', ''].includes(mainPath);
  const showGuideBarPage = ['dashboard'].includes(mainPath);
  const showGuideBar = isMobile && !landingPage && isPartner && showGuideBarPage;
  const desktopNavBarHeight = 81;
  const mobileNavBarHeight = 60;
  const guideBarHeight = 56;
  const layoutHeight = isMobile
    ? `calc(100dvh - ${mobileNavBarHeight}px${showGuideBar ? ` - ${guideBarHeight}px` : ''})`
    : `calc(100dvh - ${desktopNavBarHeight}px)`;

  return { mainPath, landingPage, showGuideBar, layoutHeight };
};
